'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TimezoneTypes = require('../constants/TimezoneTypes');

var _TimezoneTypes2 = _interopRequireDefault(_TimezoneTypes);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'FormattedRelative',

  propTypes: {
    includeSuffix: _react.PropTypes.bool,
    type: _react.PropTypes.oneOf([_TimezoneTypes2.default.PORTAL, _TimezoneTypes2.default.USER, _TimezoneTypes2.default.UTC]),
    value: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.number]).isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      includeSuffix: true,
      type: _TimezoneTypes2.default.PORTAL
    };
  },
  render: function render() {
    var _props = this.props,
        value = _props.value,
        type = _props.type,
        includeSuffix = _props.includeSuffix;


    return _react2.default.createElement(
      'span',
      null,
      _utils.formatDateTime[type](value).fromNow(!includeSuffix)
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.297/js/components/FormattedRelative.js
// module id = 338
// module chunks = 0